import { useStyles } from './styles'
import { RewardPreview } from '@/shared/ui/rewardPreview'
import { useUnit } from 'effector-react'
import { $caseContent } from '@/entities/cases'
import { RewardType } from '@/entities/cases'
import AppLoading from '../loading'

type SortStrategy = 'none' | 'byKind' | 'byAmount'

type RewardListProps = {
  folder: string
  mockForGiftCase?: boolean
  sortStrategy?: SortStrategy
}

export const RewardList = ({ folder, mockForGiftCase, sortStrategy = 'none' }: RewardListProps) => {
  const { classes } = useStyles()
  const rewards = useUnit($caseContent)?.sort((a, b) => Number(b.name) - Number(a.name))

  const sortRewards = (rewards: RewardType[], strategy: SortStrategy): RewardType[] => {
    switch (strategy) {
      case 'byKind':
        return [...rewards].sort((a, b) => b.kind - a.kind)
      case 'byAmount':
        return [...rewards].sort((a, b) => {
          const amountA = Number(a.name)
          const amountB = Number(b.name)
          return amountB - amountA
        })
      case 'none':
      default:
        return rewards
    }
  }

  const sortedRewards = rewards ? sortRewards(rewards, sortStrategy) : null

  return (
    <>
      {sortedRewards ? (
        <div className={classes.rewardListWrapper}>
          {mockForGiftCase && (
            <RewardPreview boxName={folder} text="Telegram Premium for 1 year" rarity={5} kind={0} isIcon={true} />
          )}

          {sortedRewards.map((reward, index) => (
            <RewardPreview
              key={index}
              boxName={folder}
              amountOfPoints={Number(reward.name)}
              kind={reward.kind}
              rarity={reward.rarity}
              isIcon={true}
              photo_url={reward.photo_url}
            />
          ))}
        </div>
      ) : (
        <AppLoading />
      )}
    </>
  )
}
